export default [
  { label: 'Kobieta', value: 'FEMALE' },
  { label: 'Mężczyzna', value: 'MALE' },
]
